import React from "react";

const SocialMediaItem = ({ href, icon: IconComponent }) => {
  return (
    <li className="social-item">
      <a
        className="social-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Social profile link"
      >
        <div className="ion-icon">
          <IconComponent />
        </div>
      </a>
    </li>
  );
};

export default SocialMediaItem;
